module.exports = __webpack_public_path__ + "img/unCoupon.6a02f112.png";